import { orderQuery } from 'utils/queries'

export default async ({ path, graphql, props, state }) => {
  const id = props.user.id
  const { group } = state.get('app.user')
  let sharedUUID = null

  if (group.shared) {
    sharedUUID = state.get('shared.uuid')
  }

  const result = await graphql.query(
    orderQuery({
      status: 'OPENED',
      skip: 0,
      limit: 1,
      withInfo: true,
      withAssignedTo: id,
      withSharedUUID: group.shared ? sharedUUID : null
    })
  )

  const { orders } = result
  if (orders.count > 0) {
    return path.loaded({ order: orders.orders[0] })
  } else {
    return path.noOpenOrder()
  }
}



// WEBPACK FOOTER //
// ./src/modules/App/actions/loadOrder.js